export default __webpack_public_path__ + "17275ec3c2082d8b0e47d1e1b9200a73.png";